import { useEffect, useRef } from '@max/max';
/** R007：Web 页面可见性信号源，走 document.visibilitychange。 */
export function usePageVisibility(onVisible) {
    const onVisibleRef = useRef(onVisible);
    onVisibleRef.current = onVisible;
    useEffect(() => {
        const handle = () => {
            if (document.visibilityState === 'visible')
                onVisibleRef.current();
        };
        document.addEventListener('visibilitychange', handle);
        return () => document.removeEventListener('visibilitychange', handle);
    }, []);
}
